import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ContentComponent, SingleCardLayoutComponent } from '@lyceo/shared/ui';

@Component({
  selector: 'homi-person-id-error',
  imports: [SingleCardLayoutComponent, ContentComponent, TranslocoDirective],
  templateUrl: './person-id-error.component.html',
  styleUrls: ['./person-id-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonIdErrorComponent {}
